var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layouts"},[_c('div',{staticClass:"layouts-header"},[_c('layouts-header')],1),_c('div',{staticClass:"layouts-container"},[_c('div',{staticClass:"layouts-aside"},[_c('layouts-aside')],1),_c('div',{staticClass:"layouts-main"},[_c('layouts-main')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }